import React from 'react';
import Root from './components/Root';
import './App.css';

function App() {
  return (
      <Root/>
  );
}

export default App;
